// src/components/admin/header/AdminHeaderManager.jsx
import React, { useState, useEffect } from 'react';
import fetchData from '../../../api/fetchData'; 
import { useTranslation } from 'react-i18next';

function AdminHeaderManager({ onContentUpdated }) {
    const { t } = useTranslation();
    const [logoUrl, setLogoUrl] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [saveStatus, setSaveStatus] = useState({ message: '', type: '' });

useEffect(() => {
    const loadLogo = async () => {
        setLoading(true);
        setError(null); 
        try {
            const response = await fetchData('/admin/header/admin_get_logo.php', 'GET', null, { credentials: 'include' });
            if (response && response.status === 'success') {
                setLogoUrl(response.logo_url);
            } else {
                setError(response?.message || 'Не удалось загрузить логотип.');
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };
    loadLogo();
}, []);


const handleSaveLogo = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    setSaveStatus({ message: '', type: '' });

    try {
        const response = await fetchData('/admin/header/admin_save_logo.php', 'POST', { logo_url: logoUrl }, { credentials: 'include' });

        if (response && response.status === 'success') {
            setSaveStatus({ message: t('admin.header.saveSuccess', 'Логотип успешно сохранен!'), type: 'success' });

            if (onContentUpdated) {
                console.log("AdminHeaderManager: Вызываю onSaveSuccess для обновления данных приложения...");
                onContentUpdated();
            }

        } else {
            setSaveStatus({ message: response?.message || t('admin.header.saveError', 'Ошибка сохранения логотипа.'), type: 'error' });
        }
    } catch (err) {
        setSaveStatus({ message: err.message, type: 'error' });
    } finally {
        setIsSaving(false);
        setTimeout(() => setSaveStatus({ message: '', type: '' }), 5000);
    }
};

    if (loading) return <p>{t('messages.loading')}</p>;
    if (error) return <p>{t('messages.error.generic', { details: error })}</p>;

    return (
        <div className="admin-header-manager">
            <h4>{t('admin.header.managerTitle', 'Управление Хедером')}</h4>
            <form onSubmit={handleSaveLogo}>
                <fieldset>
                    <legend>{t('admin.header.logoLegend', 'Логотип')}</legend>
                    <div>
                        <label htmlFor="logoUrl">{t('admin.header.logoUrlLabel', 'URL Логотипа')}:</label>
                        <input 
                            type="text" 
                            id="logoUrl"
                            value={logoUrl}
                            onChange={e => setLogoUrl(e.target.value)}
                            style={{ width: '100%', marginTop: '5px' }}
                        />
                    </div>
                </fieldset>
                <button type="submit" disabled={isSaving} style={{ marginTop: '10px' }}>
                    {isSaving ? t('admin.buttons.saving') : t('admin.header.saveButton', 'Сохранить логотип')}
                </button>
            </form>
            {saveStatus.message && (
                <p className={`form-status-message ${saveStatus.type === 'error' ? 'error' : 'success'}`}>
                    {saveStatus.message}
                </p>
            )}
        </div>
    );
}

export default AdminHeaderManager;